import { addDays, addMinutes } from 'date-fns';
import { getEmploymentDepartmentDisplayName } from '../../helpers/getEmploymentDepartmentDisplayName';
import { Employment } from '../models/employment';
import { Job } from '../models/job';
import { Organisation } from '../models/organisation';
import { PartialAcceptTime } from '../models/partialAcceptTime';
import { Shift } from '../models/shift';
import { getDepartmentDisplayName } from './getDepartmentDisplayName';
import { getIcalDateString } from './getIcalDateString';
import { militaryTimeToMinutes } from './time';

export function createIcsString(
  job: Job,
  shifts: Shift[] | PartialAcceptTime[],
  link?: string,
): string {
  let icsString =
    'BEGIN:VCALENDAR\r\n' +
    'VERSION:2.0\r\n' +
    'PRODID:https://app.in-pool.ch\r\n' +
    'CALSCALE:GREGORIAN\r\n';
  shifts.forEach((shift, index) => {
    icsString +=
      'BEGIN:VEVENT\r\n' +
      'SUMMARY:' +
      getDepartmentDisplayName(job.department.name, job.organisation) +
      '\r\n' +
      'X-MICROSOFT-CDO-BUSYSTATUS:BUSY\r\n' +
      'STATUS:CONFIRMED\r\n' +
      'DESCRIPTION:' +
      (job.description ? 'Beschreibung: ' + job.description + '\\n' : '') +
      (job.caseNumber ? 'Fallnummer: ' + job.caseNumber + '\\n' : '') +
      (job.organisation?.address &&
      job.organisation?.address?.street &&
      job.organisation?.address?.zip &&
      job.organisation?.address?.location
        ? 'Adresse: ' +
          job.organisation?.address?.street +
          ', ' +
          job.organisation?.address?.zip +
          ' ' +
          job.organisation?.address?.location +
          '\\n'
        : '') +
      (link ? 'Link: ' + link + '\r\n' : '') +
      'DTSTAMP:' +
      getIcalDateString(new Date()) +
      '\r\n' +
      'UID:' +
      job.date +
      index +
      '\r\n' +
      'DTSTART:' +
      getIcalDateString(
        addMinutes(
          new Date(job.date),
          militaryTimeToMinutes(shift.from.toString()),
        ),
      ) +
      '\r\n' +
      'DTEND:' +
      getIcalDateString(
        addDays(
          addMinutes(
            new Date(job.date),
            militaryTimeToMinutes(shift.to.toString()),
          ),
          shift.from > shift.to ? 1 : 0,
        ),
      ) +
      '\r\n' +
      'END:VEVENT\r\n';
  });

  icsString += 'END:VCALENDAR\r\n';
  return icsString;
}

export function getBase64Ics(icsString: string): string {
  return Buffer.from(icsString).toString('base64');
}

export function createIcsStringForEmployment(
  job: Employment,
  startDate: Date,
  endDate: Date,
  organisation?: Organisation,
  link?: string,
): string {
  const departmentDisplayName = getEmploymentDepartmentDisplayName(job);
  let icsString =
    'BEGIN:VCALENDAR\r\n' +
    'VERSION:2.0\r\n' +
    'PRODID:https://app.in-pool.ch\r\n' +
    'CALSCALE:GREGORIAN\r\n';
  icsString +=
    'BEGIN:VEVENT\r\n' +
    'SUMMARY:' +
    departmentDisplayName +
    '\r\n' +
    'X-MICROSOFT-CDO-BUSYSTATUS:BUSY\r\n' +
    'STATUS:CONFIRMED\r\n' +
    'DESCRIPTION:' +
    (job.description ? 'Beschreibung: ' + job.description + '\\n' : '') +
    (organisation?.address &&
    job.organisation?.address?.street &&
    job.organisation?.address?.zip &&
    job.organisation?.address?.location
      ? 'Adresse: ' +
        job.organisation?.address?.street +
        ', ' +
        job.organisation?.address?.zip +
        ' ' +
        job.organisation?.address?.location +
        '\\n'
      : '') +
    (link ? 'Link: ' + link + '\r\n' : '') +
    'DTSTAMP:' +
    getIcalDateString(new Date()) +
    '\r\n' +
    'UID:' +
    job.startDate +
    '\r\n' +
    'DTSTART:' +
    getIcalDateString(startDate) +
    '\r\n' +
    'DTEND:' +
    getIcalDateString(endDate) +
    '\r\n' +
    'END:VEVENT\r\n';

  icsString += 'END:VCALENDAR\r\n';
  return icsString;
}
